import { useMemo } from 'react';

export const useId = (id?: string): string => {
  // Fallback to this default id when possible.
  // Use the random value for client-side rendering only.
  // We can't use it server-side.
  return useMemo(() => id || `mcm-${Math.round(Math.random() * 1e5)}`, [id]);
};
